var _ = require('optimizely-client-fn');
var actionTypes = require('core/constants/action_types');
var Flux = require('core/flux');
var Logger = require('core/utils/logger');

var Constants = require('./constants');
var Helpers = require('./helpers');

/**
 * @return {onPageActivated}
 */
var onPageActivated = [
  /**
   * @return {onPageActivated}
   */
  function() {
    /**
     * @param {ViewEventData} viewEventData
     */
    return function(viewEventData) {
      var tags = viewEventData.eventTags;
      if (_.isEmpty(tags)) {
        Logger.debug('Not updating InterestGroup scores since page has no tags');
        return;
      }

      tags = _.map(tags, function (value, name) {
        return { viewId: viewEventData.pageId, tagApiName: name };
      });
      var affectedInterestGroups = Helpers.interestGroupsAffectedByTags(tags);

      Logger.debug('Fetching scores for InterestGroups:', affectedInterestGroups);
      Helpers.fetchScores(affectedInterestGroups).then(function (scores) {
        var attributes = _.map(scores, function (score, interestGroupId) {
          return {
            key: [Constants.INTEREST_GROUPS_PROFILE_PREFIX, interestGroupId, 'score'],
            value: score,
          };
        });

        Logger.debug('Setting new InterestGroup scores:', { scores: scores });
        Flux.dispatch(actionTypes.SET_VISITOR_ATTRIBUTES, {
          attributes: attributes,
        });
      }).catch(function (err) {
        Logger.warn('InterestGroup score fetch failed:', err);
      });
    };
  }
];

module.exports = {
  onPageActivated: onPageActivated,
};

